module.exports = __webpack_public_path__ + "img/lg_ring_y_i_1_null.17fdc2f3.png";